__turbopack_context__.v({
  "body": "popoverTip-module-scss-module__p6vjCa__body",
  "closeButton": "popoverTip-module-scss-module__p6vjCa__closeButton",
  "closeIcon": "popoverTip-module-scss-module__p6vjCa__closeIcon",
  "container": "popoverTip-module-scss-module__p6vjCa__container",
  "content": "popoverTip-module-scss-module__p6vjCa__content",
  "fadeIn": "popoverTip-module-scss-module__p6vjCa__fadeIn",
  "title": "popoverTip-module-scss-module__p6vjCa__title",
});
